<form [attr.disabled]="configurationForm().disabled">
  <glxy-form-field>
    <mat-checkbox [checked]="true" [disabled]="true">
      {{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.LOG_CRM_ACTIVITY' | translate }}
      <extended>{{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.LOG_CRM_ACTIVITY_DESCRIPTION' | translate }}</extended>
    </mat-checkbox>
  </glxy-form-field>
</form>
